export default __webpack_public_path__ + "static/media/safety2.1642a2b6.jpeg";